<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <template slot="links">
        <sidebar-item
          v-if="!isLoggedIn()"
          :link="{
            name: 'Iniciar sesión',
            icon: 'fingerprint',
            path: '/login'
          }"
        ></sidebar-item>
        <sidebar-item :link="{ name: 'Créditos', icon: 'credit_card' }">
          <sidebar-item
            v-if="!isAdmin()"
            :link="{
              name: 'Solicitar Crédito',
              path: '/dashboard'
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isLoggedIn()"
            :link="{
              name: 'Lista de Créditos',
              path: '/credit-list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Datos Personales', icon: 'perm_identity' }"
        >
          <sidebar-item
            v-if="!isAdmin() && isLoggedIn() && !hasProfile()"
            :link="{ name: 'Registro de Perfil', path: '/register-profile' }"
          ></sidebar-item>
          <sidebar-item
            v-if="isLoggedIn()"
            :link="{ name: 'Actualizar Datos', path: '/edit-own' }"
          ></sidebar-item>
          <sidebar-item
            v-if="!isAdmin() && isLoggedIn()"
            :link="{ name: 'Mis Documentos', path: '/documents' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Tickets', icon: 'class' }">
          <sidebar-item
            v-if="!isAdmin() && isLoggedIn()"
            :link="{ name: 'Crear Ticket', path: '/create-ticket' }"
          ></sidebar-item>
          <sidebar-item
            v-if="isLoggedIn()"
            :link="{ name: 'Lista de Tickets', path: '/tickets' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: 'Lista de Clientes',
            icon: 'people_outline',
            path: '/clients'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isAdmin() && isLoggedIn()"
          :link="{
            name: 'Categorías',
            icon: 'swap_vert',
            path: '/categories'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isAdmin()"
          :link="{
            name: '¿Cómo funciona?',
            icon: 'info_outline',
            path: '/how-it-works'
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import Constants from "../../../constants";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackgroundColor: "white",
      sidebarBackground: "purple",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      Constants: Constants
    };
  },
  methods: {
    isAdmin() {
      return Constants.ADMIN == Constants.getUserType();
    },
    isLoggedIn() {
      return Constants.getUserType() != null;
    },
    hasProfile() {
      return Constants.hasProfile();
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
